/**
 * @generated SignedSource<<6dcff675432f7c16dbecee582374e2e6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type administratorLayoutContainerQuery$variables = Record<PropertyKey, never>;
export type administratorLayoutContainerQuery$data = {
  readonly treeMenu: string;
  readonly user: {
    readonly email: string;
    readonly name: string;
  };
};
export type administratorLayoutContainerQuery = {
  response: administratorLayoutContainerQuery$data;
  variables: administratorLayoutContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "treeMenu",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "administratorLayoutContainerQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "administratorLayoutContainerQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "272cf59fb6f754472c2b947260f017cc",
    "id": null,
    "metadata": {},
    "name": "administratorLayoutContainerQuery",
    "operationKind": "query",
    "text": "query administratorLayoutContainerQuery {\n  treeMenu\n  user {\n    name\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4811ac561a87d0b734407f3582cb1ee";

export default node;
